export default {
    title_list: 'Centuries',
    title_page: 'Century',
    title_create_page: 'Create a century',
    title_edit_page: 'Change century',

    filter: {
        labels: {
            title: 'Title',
        }
    },

    table: {
        labels: {
            id: 'ID',
            title: 'Title',
            position: 'Position',
        }
    },

    buttons: {

    },

    form: {
        title: 'Title',
        position: 'Position',
        visible: 'Visible',
        min: 'Min year',
        max: 'Max year',
    },
}
